<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em" >
    <west-slide-left-navigation slot="navigation-top">
      <router-link
        tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: getMetaAttr('navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>

    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="servingSizeID !== -1 && StuffToEatServingSize.fetching"></nuttrema-loader>
        <form-stuff-to-eat-cred-serving-size
           v-else
          :id="id"
          :type="type"
          :meta="meta"
          :edit="true"
          :servingSizeID="servingSizeID"
          :StuffToEatDetails="StuffToEatDetails"
          :ServingSizeDetails="StuffToEatServingSize"
          @cancel="onCancelEvent"
          @submit="onFormSubmitEvent"
          @delete="onDeleteServingSizeEvent">
        </form-stuff-to-eat-cred-serving-size>
      </template>

    </nuttrema-layout-west-three-vertical>

  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import FormStuffToEatCredServingSize from './form-stuff-to-eat-cred-serving-size';

export default {
  name: 'page-stuff-to-eat-cred-serving-size',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    servingSizeID: {
      required: false,
      default: -1,
    },
  },
  components: {
    WestSlideLeftNavigation,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    FormStuffToEatCredServingSize,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatServingSize() {
      return this.$store.getters.StuffToEatServingSize(this.servingSizeID);
    },
  },
  methods: {
    ...mapActions([
      'AddStuffToEatServingSize',
      'EditStuffToEatServingSize',
      'DeleteStuffToEatServingSize',
    ]),
    onFormSubmitEvent(payload) {
      const label = 'label.serving_size';
      const action = this.servingSizeID === -1 ? this.AddStuffToEatServingSize : this.EditStuffToEatServingSize;

      action({
        id: this.id,
        type: this.type,
        servingSizeID: this.servingSizeID,
        payload,
      }).then(() => {
        this.successNotification({ label });
        this.onSuccessEvent();
      }).catch((error) => {
        this.errorNotification({ label });
        console.error(error);
      });
    },
    onDeleteServingSizeEvent() {
      const params = {
        id: this.id,
        type: this.type,
        servingSizeID: this.servingSizeID,
      };

      this.DeleteStuffToEatServingSize(params).then(() => {
        this.successNotification({ label: 'label.serving_size', message: 'message.default_success_added_message' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.serving_size', message: 'message.default_error_added_message' });
      });
    },
  },
  created() {
    if (this.servingSizeID !== -1) {
      this.$store.dispatch('GetStuffToEatServingSize', {
        id: this.id,
        type: this.type,
        servingSizeID: this.servingSizeID,
      });
    } else {
      this.$store.dispatch('InitStuffToEatServingSize', {
        servingSizeID: this.servingSizeID,
      });
    }
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatServingSize', { servingSizeID: this.servingSizeID });
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/serving-sizes/page-stuff-to-eat-cred-serving-size.vue